import { render, staticRenderFns } from "./HashtagsSetupView.vue?vue&type=template&id=c3c7fc50&scoped=true&"
import script from "./HashtagsSetupView.vue?vue&type=script&lang=ts&"
export * from "./HashtagsSetupView.vue?vue&type=script&lang=ts&"
import style0 from "./HashtagsSetupView.vue?vue&type=style&index=0&id=c3c7fc50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c7fc50",
  null
  
)

export default component.exports